var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',{attrs:{"border-variant":"white"}},[_c('h3',[_vm._v("Need help?")]),_c('p',[_vm._v("E-mail: "),_c('a',{attrs:{"href":"mailto:Courts.CSO@gov.bc.ca"}},[_vm._v("Courts.CSO@gov.bc.ca")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }